import { LOGIN_URL_WITH_REDIRECT } from './configs/auth'
import getSession from './utils/getSession'
import tracker from './utils/tracker'

const handleLogin = async () => {
  const session = await getSession()

  if (!session) window.location.href = LOGIN_URL_WITH_REDIRECT

  return
}

const handleLogout = () => {
  tracker.event({
    action: 'top_bar_menu_logout_clicked',
    category: 'logout',
  })
  localStorage.clear()
  return Promise.resolve()
}

export default {
  login: handleLogin,
  checkError: async (error) => {
    const { status, message } = error
    if (![401, 403].includes(status) && !message.match(/unauthorized/gi))
      return Promise.resolve()

    return Promise.reject()
  },
  checkAuth: async () => {
    const session = await getSession()

    return session ? Promise.resolve() : Promise.reject()
  },
  logout: handleLogout,
  getIdentity: () => {
    try {
      // if there's new data comming from auth portal we should add the keys here
      const id = localStorage.getItem('userId')
      const email = localStorage.getItem('email')
      const companyName = localStorage.getItem('companyName')
      return Promise.resolve({ email, id, companyName })
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPermissions: () => Promise.resolve(),
}
